import appConfig from '../../appConfig';
import {
  getBaseForeignApiNetworkConfig,
} from '../../common/network/apiUtils';

function accountApiFactory(storefrontApiClient) {
  const accountApi = {
    getUserInfo(params) {
      return storefrontApiClient.get(`${appConfig.checkoutUrl}/mc/kullanici-bilgileri`,
        {
          ...getBaseForeignApiNetworkConfig(),
          params,
          timeout: appConfig.checkoutTimeoutInMilliseconds,
        },
      );
    },
  };

  return accountApi;
}

export default accountApiFactory;
